// import vueMainInstance from "../../main";
import "lodash";
// import TravelServiceOrder from "../../models/travelOrder/travelServiceOrder";
// import TravelServiceOrderItem from "../../models/travelOrder/travelServiceOrderItem";
// import TravelServiceOrderItemHotel from "../../models/travelOrder/travelServiceOrderItemHotel";
// import TravelServiceOrderItemRail from "../../models/travelOrder/travelServiceOrderItemRail";
// import TravelServiceOrderItemFlight from "../../models/travelOrder/travelServiceOrderItemFlight";
// import TravelServiceOrderItemCar from "../../models/travelOrder/travelServiceOrderItemCar";
// import UserModelClass from "../../models/travelOrder/userModel";
// import TravelServiceOrderItemInsurance from "../../models/travelOrder/travelServiceOrderItemInsurance";
// import { insuranceTypeID } from "../../staticData/TravelServiceTypes";

const namespaced = true;

const state = {
  isOfferReadonly: false
};

const getters = {
  hasPermissionForEdit: (state, getters, rootState, rootGetters) => {
    if (state.editedTravelService === null) return false;
    if (state.editedTravelService.created_by_id === null) return true; //new order
    if (rootGetters.hasPermission("travelOrder")) return true;
    return rootState.Auth.userProperties.user_id === state.editedTravelService.created_by_id;
  }
};

const mutations = {
  setIsOfferReadonly(state, isOfferReadonly) {
    state.isOfferReadonly = isOfferReadonly;
  }
};

const actions = {
  // downloadAvailableCompanies({ commit, rootGetters, state }) {
  //   return new Promise((resolve, reject) => {});
  // }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
